/* eslint-disable */
/*!
* svg.select.js - An extension of svg.js which allows to select elements with mouse
* @version 2.1.2
* https://github.com/svgdotjs/svg.select.js
*
* @copyright Ulrich-Matthias Schäfer
* @license MIT
*/;
import RotateImage from '@/assets/images/rotate-element-button.png'
import DeleteImage from '@/assets/images/delete-element-button.png'
import ResizeImage from '@/assets/images/resize-element-button.png'
import EditImage from '@/assets/images/edit-element-button.png'

;(function() {
  "use strict";

  function SelectHandler(el) {

    this.el = el;
    el.remember('_selectHandler', this);
    this.pointSelection = {isSelected: false};
    this.rectSelection = {isSelected: false};

  }

  SelectHandler.prototype.init = function (value, options) {

    this.options = {};

    // Merging the defaults and the options-object together
    for (var i in this.el.selectize.defaults) {
      this.options[i] = this.el.selectize.defaults[i];
      if (options[i] !== undefined) {
        this.options[i] = options[i];
      }
    }

    this.parent = this.el.parent();
    this.nested = (this.nested || this.parent.group());

    this.moveSelection();

    // When deepSelect is enabled and the element is a line/polyline/polygon, draw only points for moving
    if (this.options.deepSelect && ['line', 'polyline', 'polygon'].indexOf(this.el.type) !== -1) {
      this.selectPoints(value);
    } else {
      this.selectRect(value);
    }

    if (this.isSvg()) {
      const groupWrapper = this.getSvgWrapper();
      this.nested.rotate(groupWrapper.transform().rotation);
    }

    this.observe();
    this.cleanup();

  };

  SelectHandler.prototype.moveSelection = function () {
    if (!this.options.scaling) {
      this.nested.matrix(new SVG.Matrix(this.el).translate(this.el.x(), this.el.y()));
    }
    else {
      const svgWrapper = this.getSvgWrapper();
      const xOffset = this.el.data('xOffset') || 0; // for curve text
      const yOffset = this.el.data('yOffset') || 0; // for curve text
      const angle = this.el.data('angle') || 0; // for curve text
      const isTextPatch = this.el.data('isTextPatch'); // for text patch
      const font = this.el.data('font'); // for text patch
      const isTextEmbroidery = this.el.data('isTextEmbroidery'); // for text patch
      const scaleValue = svgWrapper.transform().scaleX;

      if (isTextPatch) {
        const patchFont = this.el.node.dataset.font;
        let scaleWidth = this.el.width() * (scaleValue);
        let scaleHeight = this.el.height() * (scaleValue);

        const distanceXBetweenElAndScale = (this.el.width() - scaleWidth) / 2;
        const x = this.el.x() + distanceXBetweenElAndScale - xOffset;

        let distanceYBetweenElAndScale = (this.el.height() - scaleHeight) / 2;
        if (isTextEmbroidery) {
          distanceYBetweenElAndScale = (this.el.height() - scaleHeight) / 3;
        }

        if (patchFont === 'BrisenTail') {
          distanceYBetweenElAndScale = (this.el.height() - scaleHeight) / 1.5 ;
        }

        if (patchFont === 'cloistrk') {
          distanceYBetweenElAndScale = (this.el.height() - scaleHeight) / 3;
        }

        let fontOffset = 0;
        if (font === 'Freshman' && scaleHeight < this.el.height()) {
          const text = this.el.select('text').first();
          const pathId = text.textPath().attr('xlink:href');
          const path = this.el.select(pathId).first()
          const pathVal = path.array().value;
          const pathOffset = pathVal[0][2] || 95;
          fontOffset =  (pathOffset / 4 * scaleValue);
        }
        let y = this.el.y() + distanceYBetweenElAndScale - yOffset + fontOffset;

        if (angle < 0) {
          y = this.el.y() + distanceYBetweenElAndScale + (yOffset / 2 - yOffset  * scaleValue / 2);
        }

        this.nested.matrix(
          new SVG.Matrix(this.el).translate(x, y)
        );
      }
      else {
        let scaleWidth = this.el.width() * scaleValue;
        let scaleHeight = this.el.height() * scaleValue;
        const distanceXBetweenElAndScale = (this.el.width() - scaleWidth) / 2;
        const x = this.el.x() + distanceXBetweenElAndScale;
        const distanceYBetweenElAndScale = (this.el.height() - scaleHeight) / 2;
        let y = this.el.y() + distanceYBetweenElAndScale;
        this.nested.matrix(new SVG.Matrix(this.el).translate(x, y));
      }
    }
  };

  SelectHandler.prototype.isSvg = function () {
    return this.el.type === 'svg';
  };


  SelectHandler.prototype.getSvgWrapper = function () {
    return this.el.select(`#${this.el.id()}--wrapper`).get(0);
  };

  SelectHandler.prototype.selectPoints = function (value) {

    this.pointSelection.isSelected = value;

    // When set is already there we dont have to create one
    if (this.pointSelection.set) {
      return this;
    }

    // Create our set of elements
    this.pointSelection.set = this.parent.set();
    // draw the circles and mark the element as selected
    this.drawCircles();

    return this;

  };

// create the point-array which contains the 2 points of a line or simply the points-array of polyline/polygon
  SelectHandler.prototype.getPointArray = function () {
    return this.el.array().valueOf().map(function (el) {
      return [el[0] - this.el.x(), el[1] - this.el.y()];
    });
  };

// The function to draw the circles
  SelectHandler.prototype.drawCircles = function () {

    var _this = this, array = this.getPointArray();

    // go through the array of points
    for (var i = 0, len = array.length; i < len; ++i) {

      var curriedEvent = (function (k) {
        return function (ev) {
          ev = ev || window.event;
          ev.preventDefault ? ev.preventDefault() : ev.returnValue = false;
          ev.stopPropagation();

          var x = ev.pageX || ev.touches[0].pageX;
          var y = ev.pageY || ev.touches[0].pageY;
          _this.el.fire('point', {x: x, y: y, i: k, event: ev});
        };
      })(i);

      // add every point to the set
      this.pointSelection.set.add(
        // a circle with our css-classes and a touchstart-event which fires our event for moving points
        this.nested.circle(this.options.radius)
          .center(array[i][0], array[i][1])
          .addClass(this.options.classPoints)
          .addClass(this.options.classPoints + '_point')
          .on('touchstart', curriedEvent)
          .on('mousedown', curriedEvent)
      );
    }

  };

// every time a circle is moved, we have to update the positions of our circle
  SelectHandler.prototype.updatePointSelection = function () {
    var array = this.getPointArray();

    this.pointSelection.set.each(function (i) {
      if (this.cx() === array[i][0] && this.cy() === array[i][1]) {
        return;
      }
      this.center(array[i][0], array[i][1]);
    });
  };

  SelectHandler.prototype.getSizes = function () {
    const bbox = this.el.bbox();
    const isSvg = this.isSvg();
    let width = isSvg ? this.el.width() : bbox.width;
    let height = isSvg ? this.el.height() : bbox.height;

    if (this.options.scaling && this.isSvg()) {
      const svgWrapper = this.getSvgWrapper();
      width = this.el.width() * svgWrapper.transform().scaleX;
      height = this.el.height() * svgWrapper.transform().scaleX;
    }
    return { width, height };
  };

  SelectHandler.prototype.updateRectSelection = function () {
    var bbox = this.el.bbox();

    const { width, height } = this.getSizes();

    this.rectSelection.set.get(0).attr({ width, height });

    // set.get(1) is always in the upper left corner. no need to move it
    if (this.options.points) {
      this.rectSelection.set.get(2).x(width - 10).y(-15);
      this.rectSelection.set.get(3).x(width - 10).y(height - 10);
      this.rectSelection.set.get(4).x(-20).y(height - 10);

      this.rectSelection.set.get(5).center(width / 2, 0);
      this.rectSelection.set.get(6).center(width, height / 2);
      this.rectSelection.set.get(7).center(width / 2, height);
      this.rectSelection.set.get(8).center(0, height / 2);
    }
  };

  SelectHandler.prototype.selectRect = function (value) {

    var _this = this, bbox = this.el.bbox();
    const { width, height } = this.getSizes();

    this.rectSelection.isSelected = value;

    // when set is already p
    this.rectSelection.set = this.rectSelection.set || this.parent.set();

    // helperFunction to create a mouse-down function which triggers the event specified in `eventName`
    function getMoseDownFunc(eventName) {
      return function (ev) {
        ev = ev || window.event;
        ev.preventDefault ? ev.preventDefault() : ev.returnValue = false;
        ev.stopPropagation();

        var x = ev.pageX || ev.touches[0].pageX;
        var y = ev.pageY || ev.touches[0].pageY;
        _this.el.fire(eventName, {x: x, y: y, event: ev});
      };
    }

    // create the selection-rectangle and add the css-class
    if (!this.rectSelection.set.get(0)) {
      this.rectSelection.set.add(this.nested.rect(width, height).addClass(this.options.classRect));
    }

    // Draw Points at the edges, if enabled
    if (this.options.points && !this.rectSelection.set.get(1)) {
      var ename ="touchstart", mname = "mousedown";
      this.rectSelection.set.add(this.nested.circle(this.options.radius).center(0, 0).attr('class', this.options.classPoints + '_lt').on(mname, getMoseDownFunc('lt')).on(ename, getMoseDownFunc('lt')));
      this.rectSelection.set.add(
        this.nested
          .image(DeleteImage)
          .center(width - 10, - 15)
          .width(33)
          .height(33)
          .attr('class', this.options.classPoints + '_rt')
          .on('click', function () {
            _this.el.fire('delete');
          })
      );

      const canResizeClass = this.options.canResize ? '' : 'd-none';
      this.rectSelection.set.add(
        this.nested
          .image(ResizeImage)
          .center(width - 10, height - 10)
          .width(33)
          .height(33)
          .attr('class', this.options.classPoints + '_rb ' + canResizeClass)
          .on(mname, getMoseDownFunc('rb'))
          .on(ename, getMoseDownFunc('rb'))
      );

      const canEditClass = this.options.hasEditBtn ? '' : 'd-none';
      this.rectSelection.set.add(
        this.nested.image(EditImage)
          .center(-20, height - 10)
          .width(33)
          .height(33)
          .attr('class', 'svg_select_edit_button ' + canEditClass)
          .on('click', function (e) {
            e.stopPropagation();
            _this.el.fire('edit');
          })
      );

      this.rectSelection.set.add(this.nested.circle(this.options.radius).center(width / 2, 0).attr('class', this.options.classPoints + '_t').on(mname, getMoseDownFunc('t')).on(ename, getMoseDownFunc('t')));
      this.rectSelection.set.add(this.nested.circle(this.options.radius).center(width, height / 2).attr('class', this.options.classPoints + '_r').on(mname, getMoseDownFunc('r')).on(ename, getMoseDownFunc('r')));
      this.rectSelection.set.add(this.nested.circle(this.options.radius).center(width / 2, height).attr('class', this.options.classPoints + '_b').on(mname, getMoseDownFunc('b')).on(ename, getMoseDownFunc('b')));
      this.rectSelection.set.add(this.nested.circle(this.options.radius).center(0, height / 2).attr('class', this.options.classPoints + '_l').on(mname, getMoseDownFunc('l')).on(ename, getMoseDownFunc('l')));

      this.rectSelection.set.each(function () {
        this.addClass(_this.options.classPoints);
      });
    }

    // draw rotationPint, if enabled
    if (this.options.rotationPoint && ((this.options.points && !this.rectSelection.set.get(9)) || (!this.options.points && !this.rectSelection.set.get(1)))) {

      var curriedEvent = function (ev) {
        ev = ev || window.event;
        ev.preventDefault ? ev.preventDefault() : ev.returnValue = false;
        ev.stopPropagation();

        var x = ev.pageX || ev.touches[0].pageX;
        var y = ev.pageY || ev.touches[0].pageY;
        _this.el.fire('rot', {x: x, y: y, event: ev});
      };
      this.rectSelection.set.add(
        this.nested.image(RotateImage)
          .center( - 20, - 15)
          .width(33)
          .height(33)
          .attr('class', this.options.classPoints + '_rot')
          .on("touchstart", curriedEvent)
          .on("mousedown", curriedEvent)
      );

    }
  };

  SelectHandler.prototype.handler = function () {
    if (this.rectSelection.isSelected) {
      this.updateRectSelection();
    }

    this.moveSelection();

    if (this.isSvg()) {
      const groupWrapper = this.getSvgWrapper();
      const _angle = groupWrapper.transform().rotation;
      this.nested.rotate(Math.round(_angle));
    }

    if (this.pointSelection.isSelected) {
      this.updatePointSelection();
    }

  };

  SelectHandler.prototype.observe = function () {
    var _this = this;

    if (MutationObserver) {
      if (this.rectSelection.isSelected || this.pointSelection.isSelected) {
        this.observerInst = this.observerInst || new MutationObserver(function () {
          _this.handler();
        });
        this.observerInst.observe(this.el.node, {attributes: true});
      } else {
        try {
          this.observerInst.disconnect();
          delete this.observerInst;
        } catch (e) {
        }
      }
    } else {
      this.el.off('DOMAttrModified.select');

      if (this.rectSelection.isSelected || this.pointSelection.isSelected) {
        this.el.on('DOMAttrModified.select', function () {
          _this.handler();
        });
      }
    }

    this.el.off('updateSvgSelection');
    this.el.on('updateSvgSelection', function () {
      if (_this.el.type === 'svg') {
        _this.handler();
      }
    });
  };

  SelectHandler.prototype.cleanup = function () {

    //var _this = this;

    if (!this.rectSelection.isSelected && this.rectSelection.set) {
      // stop watching the element, remove the selection
      this.rectSelection.set.each(function () {
        this.remove();
      });

      this.rectSelection.set.clear();
      delete this.rectSelection.set;
    }

    if (!this.pointSelection.isSelected && this.pointSelection.set) {
      // Remove all points, clear the set, stop watching the element
      this.pointSelection.set.each(function () {
        this.remove();
      });

      this.pointSelection.set.clear();
      delete this.pointSelection.set;
    }

    if (!this.pointSelection.isSelected && !this.rectSelection.isSelected) {
      this.nested.remove();
      delete this.nested;

    }
  };


  SVG.extend(SVG.Element, {
    // Select element with mouse
    selectize: function (value, options) {

      // Check the parameters and reassign if needed
      if (typeof value === 'object') {
        options = value;
        value = true;
      }

      var selectHandler = this.remember('_selectHandler') || new SelectHandler(this);

      selectHandler.init(value === undefined ? true : value, options || {});

      return this;

    }
  });

  SVG.Element.prototype.selectize.defaults = {
    hasEditBtn: false,
    canResize: true,
    scaling: false,
    points: true,                            // If true, points at the edges are drawn. Needed for resize!
    classRect: 'svg_select_boundingRect',    // Css-class added to the rect
    classPoints: 'svg_select_points',        // Css-class added to the points
    radius: 7,                               // radius of the points
    rotationPoint: true,                     // If true, rotation point is drawn. Needed for rotation!
    deepSelect: false                        // If true, moving of single points is possible (only line, polyline, polyon)
  };
}());
/* eslint-enable */
